import { render, staticRenderFns } from "./WaitingForPushkinCardPaymentModal.vue?vue&type=template&id=59d825eb"
import script from "./WaitingForPushkinCardPaymentModal.vue?vue&type=script&lang=js"
export * from "./WaitingForPushkinCardPaymentModal.vue?vue&type=script&lang=js"
import style0 from "./WaitingForPushkinCardPaymentModal.vue?vue&type=style&index=0&id=59d825eb&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports